import { createOpenApiClient } from "@/providers/smarta-accounts/accounts-api-client";
import { getConfig } from "@/v1/config";
import { createAuthMiddleware } from "../../auth/openapiAuthMiddleware";

/**
 * Generated smarta-accounts client, talking to the accounts service the same
 * way the banking client does: through the kontax gateway under
 * `/api/kontax/accounts`, with the shared JWT auth middleware (Bearer +
 * silent-refresh on 401).
 *
 * The gateway proxies most accounts routes straight through and OVERRIDES a few
 * (customer→KAM manager set/clear) to add the kontax-only tax-case cascade —
 * the banking create-mandate override pattern. When kontax is retired, this
 * base URL points directly at the accounts service and only the auth layer
 * changes; the call sites stay identical.
 */
export const baseUrl = `${getConfig("VITE_APP_API_URL")}/api/kontax/accounts`;

export const client = createOpenApiClient({
  baseUrl,
});
client.use(createAuthMiddleware());
